import { render, staticRenderFns } from "./AtomAuthorAvatar.vue?vue&type=template&id=a989ce86&scoped=true&"
import script from "./AtomAuthorAvatar.vue?vue&type=script&lang=js&"
export * from "./AtomAuthorAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a989ce86",
  null
  
)

export default component.exports